import { combineReducers } from 'redux';

import { reducer as flash } from '../components/Flash/redux';
import {
  ns as challengeNameSpace,
  reducer as challenge
} from '../templates/Challenges/redux';
import {
  ns as curriculumMapNameSpace,
  reducer as curriculumMap
} from '../templates/Introduction/redux';
import { ns as appNameSpace } from './action-types';
import { ns as settingsNameSpace, reducer as settings } from './settings';
import { ns as AdminNameSpace } from '../templates/StaffTools/redux/action-types'
import { reducer as admin } from '../templates/StaffTools/redux'
import { FlashApp as flashNameSpace } from './types';
import { reducer as app } from '.';

export default combineReducers({
  [appNameSpace]: app,
  [challengeNameSpace]: challenge,
  [curriculumMapNameSpace]: curriculumMap,
  [flashNameSpace]: flash,
  [settingsNameSpace]: settings,
  [AdminNameSpace]: admin
});
